module.exports = __webpack_public_path__ + "img/list1.6aeba81d.png";